import styled, {css} from 'styled-components'
import media from 'src/styles/media'

export const MenuSearchWrapper = styled.header`
`

export const MenuSearchItems = styled.nav`
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: center;
`

export const MenuSearchTitle = styled.h3`
    font-size: 37px;
    font-weight: bold;
    color: var(--navy);
    margin-bottom: 25px;
    text-align: center;

    
    ${media.lessThan('md')`
        font-size: 30px;
        margin-bottom: 15px;
    `}
`

export const MenuSearchItem = styled.li`
    padding: 5px 30px;
    color: var(--navy);
    border: 1.2px solid var(--navy);
    border-radius: 23px;
    font-size: 18px;
    color: var(--navy);
    margin: 7px 11px;
    transition: all 0.4s;
    text-align: center;

    ${media.lessThan('md')`
        width: 42%;
        margin: 7px;
        font-size: 17px;
    `}

    ${props => props.active && css`
        background-color: var(--primary);
        border-color: var(--primary);
        color: var(--white);

        &:hover{
            background-color: var(--primary) !important;
        }
    `}
    
    &:hover{
        background-color: var(--navy);
        color: var(--white);
    }

    a{
        color: inherit;
        text-decoration: none;
    }
`

